import React from 'react';
import { Trans } from 'react-i18next';
import NavLink from "../NavLink/NavLink";

const NavBar = () => {
  return (
  <aside id="left">
    <nav>
      <ul>
        <li><NavLink to="/customer/"><Trans>Navigation.Customer</Trans></NavLink></li>
        <li><NavLink to="/profile/"><Trans>Navigation.Profile</Trans></NavLink></li>
        <li><NavLink to="/invoice/"><Trans>Navigation.Invoice</Trans></NavLink></li>
        <li><NavLink to="/account/"><Trans>Navigation.Account</Trans></NavLink></li>
        <li><NavLink to="/domain/"><Trans>Navigation.Domain</Trans></NavLink></li>
        <li><NavLink to="/email/"><Trans>Navigation.Email</Trans></NavLink></li>
        <li><NavLink to="/logout/"><Trans>Navigation.Logout</Trans></NavLink></li>
      </ul>
    </nav>
  </aside>
  );
};

export default NavBar;